import { ConfigError } from 'lib/errors';
import { getActiveConfig } from 'model/authConfig';

interface RuntimeConfig {
  apiBaseUrl: string;
  clientId: string;
  clientSecret: string;
}

let snapshot: RuntimeConfig | null = null;

export const setRuntimeConfig = (next: RuntimeConfig): void => {
  snapshot = { ...next };
};

const resolve = (key: keyof RuntimeConfig, errMsg: string): string => {
  if (snapshot && snapshot[key]) return snapshot[key];
  const active = getActiveConfig();
  if (active) return active[key];
  throw new ConfigError(errMsg);
};

export const getRuntimeApiBaseUrl = (): string =>
  resolve('apiBaseUrl', 'No API configuration set. Please configure an environment in the UI.');

export const getRuntimeClientId = (): string =>
  resolve(
    'clientId',
    'No client credentials configured. Please configure an environment in the UI.',
  );

export const getRuntimeClientSecret = (): string =>
  resolve(
    'clientSecret',
    'No client credentials configured. Please configure an environment in the UI.',
  );

/** Internal: tests only. */
export const resetRuntimeConfigForTest = (): void => {
  snapshot = null;
};
